module.exports = {
  CurrentPropsMap: {
    color : 'currentColor',
    text : 'currentText',
    left : 'currentX',
    top : 'currentY',
    width : 'currentW',
    height : 'currentH',
    scaleX : 'currentScaleX',
    scaleY : 'currentScaleY',
    rotate : 'currentAngle',
    popup : 'currentPopupState',
    visible : 'currentVisible',
    nextIndex : 'currentIndex',
    textColor : 'currentTextColor'
  }
};


// WEBPACK FOOTER //
// ./src/interactive/InteractiveHelper.js